//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url + Vue.prototype.$config.profile.person_education

const person_education = {
  create(payload:any,code:any) {
    let Url= url.replace("{0}",code)
    return Vue.prototype.$httpService.post(Url,payload)
  },
  edit(payload:any,code:string|number,id:string|number) {
    let Url= url.replace("{0}",code)+`/${id}`
    return Vue.prototype.$httpService.put(Url,payload)
  },
  partial_edit(id:string|number,payload:any) {
  // let Url =Vue.prototype.$config.api_url + Vue.prototype.$config.resources.relation_person
  //   return Vue.prototype.$httpService
  //   .put(Url, payload)
  },
  find(code:string|number,id:string|number) {
    let Url= url.replace("{0}",code)+`/${id}`
    return Vue.prototype.$httpService.get(Url)
  },
  delete(code:string|number,id:string|number) {
    let Url= url.replace("{0}",code)+`/${id}`
    return Vue.prototype.$httpService.delete(Url)
  },
  list(code:any,params:{}) {
    let Url= url.replace("{0}",code)
    return Vue.prototype.$httpService.get(Url ,params)
  }
}

export default person_education;

